"use client";

import { useEffect, useRef, useState } from "react";
import { useEdgesState, useNodesState } from "reactflow";
import { api } from "@/lib/trpc/client";
import OrgChartView from "@/app/dashboard/admin/institutions/[id]/org-chart/OrgChartView";
import { CustomNode } from "@/app/dashboard/admin/institutions/[id]/org-chart/CustomNode";
import { Legend } from "@/app/dashboard/admin/institutions/[id]/org-chart/Legend";
import _ from "lodash";
import { NodeData } from "@/app/dashboard/admin/institutions/[id]/org-chart/data";
interface OrgChartSectionProps {
  institutionSlug: string;
}
export default function OrgChartSection({
  institutionSlug
}: OrgChartSectionProps) {
  const {
    data: institutionData
  } = api.institutionsRouter.getInstitutionBySlug.useQuery({
    institutionSlug
  });
  const {
    data: departmentsData
  } = api.departmentRouter.getDepartmentsForInstitution.useQuery({
    institutionId: institutionData?.id || ""
  }, {
    enabled: !!institutionData?.id
  });
  const reactFlowWrapper = useRef<HTMLDivElement>(null);
  const [nodes, setNodes] = useNodesState<NodeData>([]);
  const [edges, setEdges] = useEdgesState([]);
  const {
    data: orgChartData
  } = api.orgChart.getOrgChart.useQuery({
    institutionId: institutionData?.id || ""
  }, {
    enabled: !!institutionData?.id
  });
  useEffect(() => {
    if (orgChartData) {
      setNodes(orgChartData.nodes.map(node => ({
        id: node.id,
        type: "custom",
        position: node.meta?.position || {
          x: 0,
          y: 0
        },
        data: {
          label: node.meta?.label || "",
          type: node.type.toLowerCase() as "department" | "institution" | "servant",
          category: node.type === "SERVANT" ? "Servants" : node.type === "INSTITUTION" ? "Institutions" : "Departments",
          value: node.servantId || node.departmentId || node.institutionId!
        }
      })));
      setEdges(orgChartData.edges.map(edge => ({
        id: edge.id as string,
        source: edge.fromNodeId as string,
        target: edge.toNodeId as string
      })));
    }
  }, [orgChartData, setNodes, setEdges]);
  if (!institutionData || !departmentsData) {
    return null;
  }
  return <div className="flex h-full w-full flex-col gap-4 bg-background p-4" data-sentry-component="OrgChartSection" data-sentry-source-file="OrgChartSection.tsx">
      <OrgChartView reactFlowWrapper={reactFlowWrapper} nodes={nodes} edges={edges} nodeTypes={{
      custom: CustomNode
    }} onNodesChangeAction={() => {}} onEdgesChangeAction={() => {}} onConnectAction={() => {}} onInitAction={() => {}} onNodeContextMenuAction={() => {}} onPaneContextMenuAction={() => {}} onPaneClickAction={() => {}} contextMenu={null} onDeleteNodeAction={() => {}} onAddNodeAction={() => {}} data-sentry-element="OrgChartView" data-sentry-source-file="OrgChartSection.tsx" />
      <Legend data-sentry-element="Legend" data-sentry-source-file="OrgChartSection.tsx" />
    </div>;
}